import { useState } from "react";
import { motion } from "motion/react";
import { Calendar, User, ArrowRight } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

export function Blog() {
  const [selectedCategory, setSelectedCategory] = useState("all");

  const categories = ["All", "Field Stories", "Sustainability", "Impact", "News"];

  const stories = [
    {
      id: 1,
      title: "How Homestays Transformed a Himalayan Village",
      excerpt:
        "Meet Rajesh and his community in Himachal Pradesh, where sustainable tourism has created new opportunities while preserving culture.",
      image:
        "https://images.unsplash.com/photo-1762614351385-0b3002530c1c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlY28lMjB0b3VyaXNtJTIwbW91bnRhaW4lMjB2aWxsYWdlJTIwbGFuZHNjYXBlfGVufDF8fHx8MTc3NDg3MDQ3Nnww&ixlib=rb-4.1.0&q=80&w=1080",
      category: "Field Stories",
      author: "Priya Sharma",
      date: "2026-03-20",
      readTime: "6 min read",
    },
    {
      id: 2,
      title: "The Art of Sustainable Weaving: A Success Story",
      excerpt:
        "How 40 women artisans in Tamil Nadu built a thriving textile business rooted in tradition and sustainability.",
      image:
        "https://images.unsplash.com/photo-1759738096144-b43206226765?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0cmFkaXRpb25hbCUyMHdlYXZpbmclMjB0ZXh0aWxlJTIwY3JhZnQlMjBpbmRpYXxlbnwxfHx8fDE3NzQ4NzA0Nzd8MA&ixlib=rb-4.1.0&q=80&w=1080",
      category: "Field Stories",
      author: "Ananya Desai",
      date: "2026-03-15",
      readTime: "5 min read",
    },
    {
      id: 3,
      title: "Understanding UNWTO Goal 12: Responsible Tourism",
      excerpt:
        "A deep dive into how responsible consumption and production principles apply to community-based tourism projects.",
      image:
        "https://images.unsplash.com/photo-1759738104612-5645fa10593e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYSUyMGxhbmRzY2FwZSUyMHJ1cmFsJTIwY291bnRyeXNpZGUlMjBuYXR1cmV8ZW58MXx8fHwxNzc0ODcwNDc4fDA&ixlib=rb-4.1.0&q=80&w=1080",
      category: "Sustainability",
      author: "Vikram Singh",
      date: "2026-03-10",
      readTime: "8 min read",
    },
    {
      id: 4,
      title: "From Donor to Impact: Tracking Your Contribution",
      excerpt:
        "Transparency matters. Here's how we ensure every rupee donated creates measurable impact in communities.",
      image:
        "https://images.unsplash.com/photo-1564069970419-0bc8e7b487da?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxoYW5kc2hha2UlMjBwYXJ0bmVyc2hpcCUyMGNvbGxhYm9yYXRpb24lMjBkaXZlcnNlfGVufDF8fHx8MTc3NDg3MDQ3Nnww&ixlib=rb-4.1.0&q=80&w=1080",
      category: "Impact",
      author: "Meera Iyer",
      date: "2026-03-05",
      readTime: "7 min read",
    },
    {
      id: 5,
      title: "Organic Farming Revolution in Rural Maharashtra",
      excerpt:
        "See how sustainable farming practices are increasing yields while protecting the environment.",
      image:
        "https://images.unsplash.com/photo-1774504798125-bd6eed7063fc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzdXN0YWluYWJsZSUyMGZhcm1pbmclMjBjb21tdW5pdHklMjBhZ3JpY3VsdHVyZXxlbnwxfHx8fDE3NzQ4NzA0NzV8MA&ixlib=rb-4.1.0&q=80&w=1080",
      category: "Field Stories",
      author: "Rahul Verma",
      date: "2026-02-28",
      readTime: "6 min read",
    },
    {
      id: 6,
      title: "Announcing: Partnership with UNWTO for SDG Certification",
      excerpt:
        "Immerse Foundation receives official recognition for contributions to sustainable tourism development.",
      image:
        "https://images.unsplash.com/photo-1769739576456-0aefcff3f4b9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjBvZmZpY2UlMjB0ZWFtd29yayUyMHByb2Zlc3Npb25hbHxlbnwxfHx8fDE3NzQ4NzA0Nzh8MA&ixlib=rb-4.1.0&q=80&w=1080",
      category: "News",
      author: "Ananya Desai",
      date: "2026-02-20",
      readTime: "4 min read",
    },
  ];

  const filteredStories =
    selectedCategory === "all"
      ? stories
      : stories.filter(
          (story) =>
            story.category.toLowerCase() === selectedCategory.toLowerCase()
        );

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-32 bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-5xl md:text-7xl mb-6">Stories & Insights</h1>
            <p className="text-xl md:text-2xl opacity-90 leading-relaxed">
              Field stories, impact updates, and insights on sustainable
              development from across India.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-8 bg-white border-b border-border sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <Button
                key={category}
                variant={
                  selectedCategory === category.toLowerCase() || (selectedCategory === "all" && category === "All")
                    ? "default"
                    : "outline"
                }
                onClick={() => setSelectedCategory(category.toLowerCase())}
              >
                {category}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Stories Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredStories.map((story, index) => (
              <motion.div
                key={story.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="group overflow-hidden hover:shadow-lg transition-shadow h-full flex flex-col">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={story.image}
                      alt={story.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <CardContent className="p-6 flex flex-col flex-1">
                    <Badge variant="secondary" className="mb-3 w-fit">
                      {story.category}
                    </Badge>
                    <h3 className="text-xl mb-3 line-clamp-2">{story.title}</h3>
                    <p className="text-muted-foreground mb-4 line-clamp-3 flex-1">
                      {story.excerpt}
                    </p>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground mb-4">
                      <div className="flex items-center gap-1">
                        <User size={14} />
                        <span>{story.author}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Calendar size={14} />
                        <span>
                          {new Date(story.date).toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                          })}
                        </span>
                      </div>
                    </div>
                    <Button variant="ghost" className="w-full justify-between group">
                      Read More
                      <ArrowRight
                        className="transition-transform group-hover:translate-x-1"
                        size={18}
                      />
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
